import type { Channel, HomeNotification } from '../stores/types/home';
import { getAuthenticatedRequestInit } from './utils';

export const CreateNotification = (token: string, notification: HomeNotification) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notifications/create`, {
		method: 'POST',
		body: JSON.stringify({ notification }),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (!result.ok) {
			throw new Error('Unable to create notification');
		}
	}).catch(error => {
		console.error(error);
	});
};

export const LoadNotifications = (token: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notifications/get`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then(async result => {
		if (result.ok) {
			const notifications = await result.json();
			const cleanedNotifications = notifications.map((notification: any) => {
				notification.data = JSON.parse(notification.data);
				return notification;
			});
			return cleanedNotifications;
		} else {
			throw new Error('Unable to create notification');
		}
	}).catch(error => {
		console.error(error);
	});
};

export const SetNotificationsSeen = (token: string, notificationIDs: number[]) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notifications/set-seen`, {
		method: 'POST',
		body: JSON.stringify({ notificationIDs }),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (!result.ok) {
			throw new Error('Unable to set notifications as seen');
		} else {
			return true;
		}
	}).catch(error => {
		console.error(error);
	});
};

export const FindUser = (token: string, email: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/home/find-user`, {
		method: 'POST',
		body: JSON.stringify({ email }),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (!result.ok) {
			throw new Error('Unable to get user');
		} else {
			return result.json();
		}
	}).catch(error => {
		console.error(error);
	});
};

export const LoadTeams = (token: string, channels: { events_legacy_channels: Channel[], gr_channels: Channel[] }) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/home/load-teams`, {
		method: 'POST',
		body: JSON.stringify({ channels }),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (!result.ok) {
			throw new Error('Unable to load teams');
		} else {
			return result.json();
		}
	}).catch(error => {
		console.error(error);
	});
};
